import React, { useState, useEffect, useContext } from 'react';
import { ToggleButton, ToggleButtonGroup } from '@mui/material';
import { Tabs, Tab } from '@mui/material';
import { useNavigate, useLocation } from 'react-router-dom';
import { dashboardValues } from '../Constants/constants';
import renderTabContent from './RenderTabs';
import { LoginContext } from './LoginContext';
import './Pages.css';

function Dashboard({ value }) {
    const location = useLocation();
    const [alignment, setAlignment] = useState(value);
    const [tabValue, setTabValue] = useState(0);
    const navigate = useNavigate();
    const { userRole } = useContext(LoginContext);

    useEffect(() => {
        const path = location.pathname.split('/').pop();
        setAlignment(path);
    }, [location]);

    const handleChange = (event, newAlignment) => {
        if (userRole === 'vendor' && newAlignment !== 'exceptions') {
            return; // Prevent navigation for vendors
        }

        if (newAlignment !== null) {
            setAlignment(newAlignment);
            setTabValue(0);
            navigate(`/dashboard/${newAlignment}`);
        }
    };

    const handleTabChange = (event, newValue) => {
        setTabValue(newValue);
        console.log('Tab changed:', newValue);
    };
console.log('dashboardValues:', dashboardValues); // Debugging line
    const selectedDashboard = dashboardValues.find((item) => item.value === alignment);
    console.log('Selected Dashboard:', selectedDashboard); // Debugging line
    const hasTabs = !!(selectedDashboard && selectedDashboard.tabs);

    const filteredDashboardValues = dashboardValues.filter((button) => {
        if (userRole === 'vendor') {
            return button.value === 'exceptions';
        }
        return true;
    });

    return (
        <div>
            <ToggleButtonGroup
                color="primary"
                value={alignment}
                exclusive
                onChange={handleChange}
                aria-label="Menu Navigation"
                className="toggle-button-group"
            >
                {filteredDashboardValues.map((button) => (
                    <ToggleButton
                        key={button.value}
                        value={button.value}
                        className={`toggle-button ${alignment === button.value ? 'toggle-button-selected' : ''}`}
                        disabled={userRole === 'vendor' && button.value !== 'exceptions'}
                    >
                        {button.label}
                    </ToggleButton>
                ))}
            </ToggleButtonGroup>

            {hasTabs && (
                <div className="tabs-container">
                    <Tabs value={tabValue} onChange={handleTabChange} aria-label="sub tabs">
                        {selectedDashboard.tabs.map((tab) => {
                            const isTabDisabled = userRole === 'vendor' && tab.disabledForVendor;
                            console.log(`Tab: ${tab.label}, Disabled for Vendor: ${isTabDisabled}`); // Debugging line

                            return (
                                <Tab 
                                    key={tab.index} 
                                    label={tab.label}
                                    disabled={isTabDisabled}
                                />
                            );
                        })}
                    </Tabs>
                </div>
            )}

            <div>
                {renderTabContent(alignment, tabValue, hasTabs)}
            </div>
        </div>
    );
}

export default Dashboard;
